import { useMutation } from '@tanstack/react-query';
import { getModules } from '../queries/module';
import { useNewModuleStore } from '../stores/newModuleStore';

export function useModule() {
  const setModules = useNewModuleStore.getState().setModules;

  const { mutate, isPending, isError, data } = useMutation({ 
    mutationKey: ['module'], 
    mutationFn: (modulo: string) => getModules(modulo),
    onSuccess: (result) => {
      setModules(result)
    },
    retry: false
  });

  return { mutate, isPending, isError, data };
}
